import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';


@Injectable({ providedIn: 'root' })
export class CspService {
  private nonce: string | null = null;

  constructor(private http: HttpClient) {}

  fetchNonce() {
    const url = environment.apiUrl + environment.csp.nonceEndpoint;
    return this.http.get<{ nonce: string }>(url);
  }

  setNonce(nonce: string) {
    this.nonce = nonce;
  }

  getNonce(): string | null {
    return this.nonce;
  }
}
